import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

const UNIVERSES = {
    'mcbookie': { label: 'MCB' },
    'star': { label: 'STAR' },
    'spin': { label: 'SPIN' }
};

const mapStateToProps = state => {
    const universe = state.user.getIn( [ 'data', 'universe' ] );

    return {
        universe,
        universePrefix: get( UNIVERSES, `${universe}.label` ) || universe
    };
};

export default connect( mapStateToProps );
